import React, { useState } from "react";
import { useGetMembersOverview } from "../../hooks/membersOverView/membersOverView.hooks";
import { FontFamily } from "../../Constants/Enums/FontFamily.enums";
import { Colors } from "../../Constants/colors";
import {
  DISPLAY,
  ALIGN_ITEMS,
  JUSTIFY_CONTENT,
  SPACING,
  FONT_SIZE,
  FONT_WEIGHT,
  FLEX_DIRECTION,
} from "../../Constants/Enums/styles.enum";
import StudentsIcon from "./../../images/students-dashboard.svg";
import TeachersIcon from "./../../images/teacher-dashboard-com.svg";
import ParentsIcon from "./../../images/parents-dashboard.svg";

export const TotalMembersOverview = () => {
  const { isLoading: isMembersOverViewLoading, data: membersOverView } =
    useGetMembersOverview();

  if (isMembersOverViewLoading) return <></>;

  const transformedData = [
    {
      image: StudentsIcon,
      title: "Students",
      value: membersOverView?.totalStudentsCount,
      color: "#3cb878",
      bgGradient: "linear-gradient(135deg, #3cb878 0%, #2a9d5f 100%)",
    },
    {
      image: TeachersIcon,
      title: "Teachers",
      value: membersOverView?.totalTeachersCount,
      color: "#3f7afc",
      bgGradient: "linear-gradient(135deg, #3f7afc 0%, #2a5fd4 100%)",
    },
    {
      image: ParentsIcon,
      title: "Parents",
      value: membersOverView?.totalParentsCount,
      color: "#ffa001",
      bgGradient: "linear-gradient(135deg, #ffa001 0%, #e68a00 100%)",
    },
  ];

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
        gap: SPACING.S24,
      }}
    >
      {transformedData.map(
        ({ image, title, value, color, bgGradient }, index) => (
          <MemberCard
            key={index}
            image={image}
            title={title}
            value={value}
            color={color}
            bgGradient={bgGradient}
          />
        ),
      )}
    </div>
  );
};

const MemberCard = ({
  image,
  title,
  value,
  color,
  bgGradient,
}: {
  image: string;
  title: string;
  value?: number;
  color: string;
  bgGradient: string;
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      style={{
        backgroundColor: Colors.White,
        borderRadius: SPACING.S12,
        padding: SPACING.S28,
        transition: "all 0.3s ease",
        transform: isHovered ? "translateY(-4px)" : "translateY(0)",
        cursor: "pointer",
        minHeight: "160px",
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div
        style={{
          display: DISPLAY.FLEX,
          alignItems: ALIGN_ITEMS.CENTER,
          gap: SPACING.S24,
        }}
      >
        {/* Icon Circle */}
        <div
          style={{
            width: "100px",
            height: "100px",
            borderRadius: "50%",
            display: DISPLAY.FLEX,
            justifyContent: JUSTIFY_CONTENT.CENTER,
            alignItems: ALIGN_ITEMS.CENTER,
            position: "relative",
            overflow: "hidden",
            flexShrink: 0,
            transition: "transform 0.3s ease",
            transform: isHovered ? "scale(1.05)" : "scale(1)",
          }}
        >
          <img
            src={image}
            alt={`${title}-icon`}
            style={{
              width: "50px",
              height: "50px",
              position: "relative",
              zIndex: 1,
            }}
          />
          <div
            style={{
              backgroundColor: color,
              width: "100%",
              height: "100%",
              opacity: 0.12,
              position: "absolute",
              top: 0,
              left: 0,
            }}
          />
        </div>

        {/* Content */}
        <div
          style={{
            flex: 1,
            display: DISPLAY.FLEX,
            flexDirection: FLEX_DIRECTION.COLUMN,
            gap: SPACING.S8,
          }}
        >
          <div
            style={{
              fontFamily: FontFamily.POPPINS_REGULAR,
              fontSize: FONT_SIZE.F14,
              color: Colors.Grey,
              textTransform: "uppercase",
              letterSpacing: "0.8px",
              fontWeight: FONT_WEIGHT.MEDIUM,
            }}
          >
            {title}
          </div>
          <div
            style={{
              fontFamily: FontFamily.POPPINS_REGULAR,
              fontSize: FONT_SIZE.F36,
              color: Colors.DarkGrey,
              lineHeight: 1,
            }}
          >
            {value ?? 0}
          </div>
          <div
            style={{
              fontFamily: FontFamily.ROBOTO_REGULAR,
              fontSize: "12px",
              color: Colors.Grey,
              marginTop: SPACING.S4,
              lineHeight: "1.4",
            }}
          >
            Total registered members
          </div>
        </div>
      </div>
    </div>
  );
};
